import axios from '../axios';
import {
    MENU_START_JOB_PATH,
    getMenuJobsListPath,
    getMenuStatusPath,
} from '../ApiUrl';

/**
 * POST /start-job (multipart)
 * Fields: kitchen_name, file, merchant_email, admin_email
 * Returns: { success: true, job_id }
 */
export const startMenuJobAPI = async (formData) => {
    try {
        const response = await axios.post(MENU_START_JOB_PATH, formData);
        return response;
    } catch (error) {
        console.log('startMenuJobAPI catch block', error);
        return { hasError: true, message: error?.message || 'Failed to start menu job.' };
    }
};

/**
 * GET /jobs/list?kitchen_name=...&status=...
 */
export const getMenuJobsListAPI = async (params = {}) => {
    try {
        const response = await axios.get(getMenuJobsListPath(params));
        return response;
    } catch (error) {
        console.log('getMenuJobsListAPI catch block', error);
        return { hasError: true, message: error?.message || 'Failed to fetch job list.' };
    }
};

/**
 * GET /status/:job_id
 * Returns: { success: true, data } — data is the job object
 */
export const getMenuStatusAPI = async (jobId) => {
    try {
        const response = await axios.get(getMenuStatusPath(jobId));
        return response;
    } catch (error) {
        console.log('getMenuStatusAPI catch block', error);
        return { hasError: true, message: error?.message || 'Failed to fetch job status.' };
    }
};
